function PrimaryButtonNoClick(props){
    const buttonText = props.buttonText
    return (
        <button className='bg-primary ba white pa1 pl3 pr3 br2 b--primary o-50 primary-button-no-click'>
            {buttonText}
        </button>
    )
}

export default PrimaryButtonNoClick;